import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { UserService } from '../auth/user.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PropertyService {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly userService: UserService
    ) {
    }

    getProperties(): Promise<any> {
        return firstValueFrom(this.httpClient.get(`${environment.api_server_url}/api/properties`)).then((res) => {
            return res;
        });
      }

    getMindmap(id: number): Promise<any> {
        const headers = new HttpHeaders().set('x-access-token', this.userService.user.token);
        return firstValueFrom(this.httpClient.get(`${environment.api_server_url}/api/property/${id}`, { headers })).then((res) => {
            return res;
        });
    }

  getPropertyByUuid(uuid: string): Promise<any> {
    return firstValueFrom(this.httpClient.get(`${environment.api_server_url}/api/property-by-uuid/${uuid}`, {  }));
  }
  getPropertyByUuidNoCache(uuid: string): Promise<any> {
    const headers = new HttpHeaders().set('skip-cache', "true");
    return firstValueFrom(this.httpClient.get(`${environment.api_server_url}/api/property-by-uuid/${uuid}`, {headers}));
  }

  create(reental: any): Promise<any> {
    const headers = new HttpHeaders().set('x-access-token', this.userService.user.token);
    return firstValueFrom(this.httpClient.post(`${environment.api_server_url}/api/reental`, reental, { headers }));
  }

  update(property: any): Promise<any> {
    const headers = new HttpHeaders().set('x-access-token', this.userService.user.token);
    return firstValueFrom(this.httpClient.put(`${environment.api_server_url}/api/property`, {property}, { headers }));
  }

  deleteProperty(id: number): Promise<any> {
    const headers = new HttpHeaders().set('x-access-token', this.userService.user.token);
    return firstValueFrom(this.httpClient.delete(`${environment.api_server_url}/api/property/${id}`, { headers }));
  }

}
